module.exports = __webpack_public_path__ + "img/route_sender_letter_1.8cb93b2a.png";